import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './WorkspaceCom2.css';
import Button from '../Components/Common/Button';
import api from '../api/axios';
import { useTheme } from '../ThemeContext';
import { toast } from "react-toastify";

const WorkspaceCom2 = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const {
    workspaceName = 'Finance',
    industry = '',
    department = ''
  } = location.state || {};

  const [email, setEmail] = useState('');
  const [invitedEmails, setInvitedEmails] = useState([]);

  const addEmail = () => {
    if (email && !invitedEmails.includes(email)) {
      setInvitedEmails([...invitedEmails, email]);
      setEmail('');
    }
  };

  const removeEmail = (emailToRemove) => {
    setInvitedEmails(invitedEmails.filter((e) => e !== emailToRemove));
  };

  const handleFinalCreation = async () => {
    setLoading(true);
    try {
      const response = await api.post('/workspaces', {
        workspace_name: workspaceName,
        workspace_type: 'company',
        industry: industry,
        department: department,
        invited_emails: invitedEmails
      });

      console.log('Workspace Created:', response.data);
      navigate('/home');
 } catch (err) {

  console.error('Failed to create workspace:', err);

  toast.error(
    err.response?.data?.message ||
    'Error creating workspace. Please try again.'
  );

} finally {
  setLoading(false);
}

};

  return (
    <div className="workspace-wrapper">
      <div
        className="workspace-card text-center"
        style={{
          backgroundColor: '#F5F5F5',
          color: 'var(--text-main)',
          borderColor: 'var(--border-color)'
        }}
      >
        <div className="logo-section">
          <img
            src="/images/kinenew.svg"
            alt="KINEXAR"
            className="title-img"
            style={{ filter: theme === 'dark' ? 'brightness(0) invert(1)' : 'none' }}
          />
        </div>

        <div className="mb-4">
<h2 className="workspace-header"><strong>invite Your Team</strong></h2>
        </div>

        <div className="form-container mx-auto">
          <div className="text-start mb-4">
            <div className="d-flex align-items-baseline">
              <h3 className="display-workspace-name mb-0">{workspaceName}</h3>
              <span className="ms-2 company-tag">Company</span>
            </div>
            <hr className="header-divider" />
          </div>

          <p className="section-instruction text-start mb-3">
            Add members to this workspace:
          </p>

          <div className="text-start mb-3">
            <label className="workspace-label">Invite via Email</label>
            <div className="invite-row">
              <input
                type="email"
                className="form-control custom-input"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <button
                type="button"
                className="add-btn"
                onClick={addEmail}
                disabled={loading}
              >
                Add
              </button>
            </div>
          </div>

          <div className="email-tags-container mb-5">
            {invitedEmails.map((e, index) => (
              <div
                key={index}
                className="email-tag d-inline-flex align-items-center me-2 mb-2"
              >
                <span>{e}</span>
                <button
                  type="button"
                  className="ms-2 close-tag"
                  onClick={() => removeEmail(e)}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>

          <div className="workspace-actions">
            <button
              type="button"
              className="skip-btn"
              onClick={handleFinalCreation}
              disabled={loading}
            >
              Skip for Now
            </button>

            <Button
              className="create-workspace-btn"
              onClick={handleFinalCreation}
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create Workspace'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceCom2;